import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
  
        <div style={{
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  padding: '0 20px'
}}>
  <img 
    src="img/feature/feature_01.png" 
    alt="gallery" 
    style={{
      maxWidth: '100%',
      height: 'auto',
      display: 'block'
    }}
  />
</div>
<div style={{
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  padding: '0 20px'
}}>
  <img 
    src="img/feature/feature_02.png" 
    alt="gallery" 
    style={{
      maxWidth: '100%',
      height: 'auto',
      display: 'block'
    }}
  />
</div>
<div style={{
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  padding: '0 20px'
}}>
  <img 
    src="img/feature/feature_03.png" 
    alt="gallery" 
    style={{
      maxWidth: '100%',
      height: 'auto',
      display: 'block'
    }}
  />
</div>
        {/* <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div> */}
      </div>
    </div>
  );
};
